/**
 * Number formatting utilities for consistent display across the app
 */

/**
 * Format a number with thousands separators
 * @param {number} value - The number to format
 * @returns {string} - Formatted number string (e.g., 12000 -> "12,000")
 */
export function formatNumber(value) {
  if (value == null || isNaN(value)) return "0";
  return Number(value).toLocaleString("en-US");
}

/**
 * Format a currency value with $ prefix and thousands separators
 * @param {number} amount - The amount to format
 * @param {boolean} showCents - Whether to show cents (default: true)
 * @returns {string} - Formatted currency string (e.g., 12000.50 -> "$12,000.50")
 */
export function formatCurrency(amount, showCents = true) {
  if (amount == null || isNaN(amount)) return "$0";
  const num = Number(amount);
  if (showCents) {
    return "$" + num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  return "$" + Math.round(num).toLocaleString("en-US");
}
